// Згенеровано scripts/update-icon-list.js (npm run make-icons) — не редагувати вручну
export const SPRITE_VERSION = '5cb2e69dfd';
